module.exports = __webpack_public_path__ + "static/img/glenn-carstens-peters-203007-unsplash.cc71ab9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides/New folder/glenn-carstens-peters-203007-unsplash.jpg
// module id = MQ5p
// module chunks = 1